import React, { useState } from "react";

import "../../src/assets/css/Features.css"

import { fetchFeatures, fetchPremiumFeatures } from "../api/MarketingApi";
import pageheader from "../assets/images/page-header.jpg";
import { useNavigate } from "react-router-dom";

export default function PremiumFeatures() {
    const navigate = useNavigate();
    const [featuresList, setFeaturesList] = useState([]);

    let FetchPremiumFeatureList = async () => {
        let resp = await fetchPremiumFeatures({});
        console.log(resp);

        setFeaturesList(resp)
    }

    React.useEffect(() => {
        try {
            FetchPremiumFeatureList()
        }
        catch (error) {
            console.log(error);
        }
    }, [])

    return (
        <>
            <section
                className="hero-area bg_img"
                style={{
                    backgroundImage: `url(${pageheader})`,
                }}>
                <div className="container">
                    <h1 className="title m-0">Premium Features</h1>
                </div>
            </section>
            <div className="breadcrumb-section">
                <div className="container">
                    <ul className="breadcrumb">
                        <li style={{ cursor: "pointer" }} onClick={() => navigate("/")}> Home</li>
                        <div style={{ margin: "0px 10px 0px 10px" }}> - </div>
                        <li>Premium Features</li>
                    </ul>
                </div>
            </div>

            <section>
                <div className="updates">
                    <div style={{
                        border: "2px solid #b9b9ba",
                        backgroundColor: "#d8d7d7",
                        padding: "16px",
                        borderRadius: "10px",
                        width: "60%",
                        margin: "24px auto 12px auto",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "12px",
                        boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.1)"
                    }}
                    >
                        <h2 style={{ fontSize: "2rem", fontWeight: "600" }}>BuildID Client Pricing & Features</h2>
                        <h6 style={{ color: "#3a3a3a", fontSize: "1.2rem", fontWeight: "500", lineHeight: "1.7" }}>
                            Start with everything you need for just $30. <br />
                            Add extra features anytime for just $5 per license per year. <br />
                            No surprises. No hidden fees. Just flexible pricing that scales with your business. <br />
                            <span style={{ fontWeight: "600", lineHeight: "4" }}> See below for the full list of features.</span>
                        </h6>
                    </div>
                    {featuresList.length > 0 ?
                        featuresList.map((feature, index) =>
                            <section key={index} className={index % 2 == 0 ? "padding-top bg-f3 padding-bottom" : "gray-back reseller-about padding-top padding-bottom"} >
                                <div className="container p-lg-0">
                                    <div className={`row m-0 flex-wrap-reverse justify-content-between picture-pos ${index % 2 == 0 ? 'picture-pos-reverse' : ""}`}>
                                        <div className="col-lg-6">
                                            <div className="text-center reseller-about-thumb update-img">
                                                <img src={feature.pictureUrl} alt="BuilderID" />
                                            </div>
                                        </div>
                                        <div className="col-lg-6 p-0" >
                                            <div className="overview-non-masking-left padding-top padding-bottom mr-lg-15-xl mt-max-md--40">
                                                <div className="news-card-container">
                                                    <h2 className="title"> {feature.name}</h2>
                                                    <div>
                                                        {feature.features.split(/\r?\n|\n/g).map((desc, index) => <p style={{ margin: "12px 0px 12px 0px" }} key={index}>{desc}</p>)    /* Splits String so it creates a new line to be more readable */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        ) : ""}
                </div>
            </section>
        </>
    );
}
